/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PersonProfileCareer, PersonProfileState, SalesAlignmentItem, SalesAlignmentRow } from 'Types/GlobalTypes';
import {
  AIDigestResponse,
  AIDigestResponseData,
  CareerDataObjectType,
  CareerTabDataObjectType,
  CommonalitiesData,
  CreateDigestResponse,
  Executive,
  GeneratedEmail,
  InsightsCompatibility,
  MultiSalesAlignment,
  PersonAchievementType,
  PersonalityInfo, PersonalityInfoResponse,
  PersonalityInsights,
  PersonCard,
  PersonCardResponse,
  PersonCareerResponseType,
  PersonCompanyState, PersonCurrentPositionCompanyDataType,
  PersonEducationDataType, PersonHighlightedInfo,
  PersonIntentData, PersonManualBoardAndCommitteesDataObject, PersonNews,
  PersonPersonalDetailsDataType, PersonPersonalDetailsType,
  PersonPersonalInfo,
  PersonProfile, PersonProfileDownloadType, PersonProfilePersonalDetailInfo,
  PersonResponseType, PersonResultType, PersonSocialType,
  PersonThemeResponse, PopUpResponse, PopupValuesType,
  ResponseExport,
  SocialLinks,
  WorkbenchStatsResponseType, AlignmentList, AlignmentStaffByRowId
} from 'Types/PersonTypes';
import {

  AddToFavoriteRequest,
  CreateAIDigestRequest,
  EditPhoneEmailRequest,
  EmailFeedback,
  ExportSimilarPeopleRequest,
  GenerateEmail,
  GetAllGroups,
  GetMultiSalesRequest,
  GetPersonCommonalitesRequest,
  GetPersonProfileRequest,
  GetPersonProfileSocialRequest, NotableStaffRequest, PersonCompanyCareer, SimilarPeopleRequest,
  UpdatePersonProfileFollow,
} from 'Types/RequestBodies';

import { getLocalStorageValue } from 'Utils/UtilityFunctions';
import { Company, NotableStaff } from 'Types/CompaniesTypes';
import { getPersonCommonalities } from 'Saga/PersonProfileSaga';
import { MostActiveGroups } from 'Types/GroupsTypes';
import { PersonVideosType } from '../Types/PersonTypes.d';

export const initialState: PersonProfileState = {
  tabs: ['xiQ insights', 'Strategic Highlights', 'News', 'Videos', 'Career', 'Personal'],
  cardResult: [],
  popups: {
    allowFullView: false,
    contactusEmail: '',
    popupHtml: '',
    popupText: '',
    showPlanPopup: 0,
    popupHeading: '',
    isDownloadPopup: false,
    callToAction: '',
    buttonText: '',
  },
  profile: {
    loading: false,
    data: {} as PersonProfile,
    followLoading: false,
  },
  similarPeopleLoading: false,
  insights: {
    loading: false,
    insightsData: [],
  },
  news: {
    loading: false,
    page: 0,
    articles: [],
    title: '',
    seenArticleIds: [],
  },
  intent: {
    loading: false,
    data: [] as string[],
    contactusEmail: '',
    popupText: '',
    intentAllowed: 0,
    popupHeading: '',
    url: '',
  },
  personalDetails: {
    highlightedInfo: [],
    personalInfo: {
      about: '',
      address: '',
      phoneNumber: '',
      family: '',
    },
    hobbies: [],
    interests: [],
    loading: false,
    title: '',
  },
  career: {
    loading: false,
    title: '',
    count: 0,
    achievements: {
      data: [] as PersonAchievementType[],
      title: '',
    },
    manualAchievements: {
      title: '',
      data: '',
    },
    skills: {
      title: '',
      data: [] as string[],
    },
    boardsAndCommittees: {
      title: '',
      data: [] as string[],
    },
    manualBoardsAndCommittees: {
      title: '',
      data: '',
    },
    volunteerWork: {
      title: '',
      data: '',
    },
    workHistory: {
      title: '',
      data: [] as PersonCompanyState[],
    },
    currentPosition: {
      title: '',
      data: [] as PersonCurrentPositionCompanyDataType[],
    },
    educationHistory: {
      title: '',
      data: [] as PersonEducationDataType[],
    },
  } as unknown as PersonProfileCareer,
  video: {
    loading: false,
    page: 0,
    articles: [],
  },
  downloadProfile: {
    loading: false,
    link: '',
  },
  workbenchStats: {
    loading: false,
    isEmptyWorkbenchStats: true,
    data: [] as WorkbenchStatsResponseType[],
  },
  newsFlurry: {},
  socialFlurry: {},
  videoFlurry: {},
  newsApiCall: false,
  socialApiCall: false,
  videoApiCall: false,
  message: '',
  searchedPerson: {
    loading: false,
    insightsData: [],
    selectedPerson: {} as Executive,
  },
  bookADemoURL: '',
  newNotes: 0,
  showLanguagePopup: false,
  chatGptAllowed: 0,
  personNotesAvailable: 0,
  personalityDrawerOpen: false,
  blip: 1,
  email: {
    generateEmailData: {} as GenerateEmail,
    emailLoading: false,
    generatedEmailView: false,
    generatedEmail: {} as GeneratedEmail,
  },
  feedbackSubmitted: false,
  personFaqs: {
    loading: false,
    faqs: [] as string[],
  },

  similarPeopleData: {
    page: 1,
    people: [],
    loading: false,
    loaded: false,
    ended: false,
    count: 0,
    title: '',
    name: '',
    savedId: 0,
  },
  similarPeopleFilters: {
    loading: false,
    loaded: false,
    filters: [],
    appliedFilters: [],
  },
  exportSimilarPeopleLoading: false,
  editPhoneEmailLoading: false,
  isEditingEmail: false,
  isEditingPhone: false,
  isRecommended: false,
  dossierAllowed: false,
  personThemeLoading: false,
  personThemeResponse: {
    themes: [],
    responseId: 0,
  },
  personDigestLoading: false,
  redirectWorkbench: false,
  showDigestPopup: false,
  createDigestData: {
    campaignId: 0,
    emailId: 0,
  },
  commonalities: {
    dataList: [],
    title: '',
    loading: false,
  },
  commonGroups: {
    allPersonGroups: [],
    loading: false,
    count: 0,
    loaded: false,
  },
  salesAlignmentPersons: {
    loading: false,
    rows: [] as SalesAlignmentRow[],
  },
  salesAlignmentInsightsCache: {},
  alignmentPeopleStaff: {} as AlignmentStaffByRowId,
  alignmentRowStaff: {} as AlignmentStaffByRowId,
  currentSections: [] as string[],
  searchedMultiSalesPersonLoading: false,
  searchedMultiSalesPerson: {
    person: {} as Executive,
    rowId: 0,
  },
  searchedAffinityMSPersonLoading: false,
  searchedAffinityMSPerson: {
    person: {} as Executive,
    rowId: 0,
  },
};

const PersonProfileSlice = createSlice({
  name: 'personProfile',
  initialState,
  reducers: {
    getPersonProfile(state, action: PayloadAction<GetPersonProfileRequest>) {
      if (state.profile.loading === false) { state.profile.loading = true; }
    },
    getPersonTheme(state, action: PayloadAction<GetPersonProfileRequest>) {
      state.personThemeLoading = true;
    },
    setPersonTheme(state, action: PayloadAction<PersonThemeResponse>) {
      state.personThemeLoading = false;
      state.personThemeResponse = action.payload.response;
    },
    createAIDigest(state, action: PayloadAction<CreateAIDigestRequest>) {
      state.personDigestLoading = true;
    },
    workbenchRedirect(state, action: PayloadAction<boolean>) {
      state.redirectWorkbench = action.payload;
    },
    setPersonDigest(state, action: PayloadAction<AIDigestResponseData>) {
      state.personDigestLoading = false;
      state.createDigestData = action.payload;
    },
    setShowDigestPopup(state, action: PayloadAction<boolean>) {
      state.showDigestPopup = action.payload;
    },
    setPersonProfile(state, action: PayloadAction<PersonCardResponse>) {
      const { payload } = action;
      const {
        result, popUpResponse, bookADemoURL, newNotes, personNotes, chatgptAllowed,
        showLanguagePopup, dossierAllowed, blip
      } = payload;
      state.newNotes = newNotes;
      state.blip = blip;
      state.dossierAllowed = dossierAllowed;
      state.showLanguagePopup = showLanguagePopup;
      state.personNotesAvailable = personNotes;
      state.cardResult = result;
      state.bookADemoURL = bookADemoURL;
      state.chatGptAllowed = chatgptAllowed;
      const { data: newData } = state.profile;
      let newTabs = state?.tabs;
      const {
        allowFullView, showPlanPopup,
        contactusEmail, popupHtml, popupText,
        popupHeading, callToAction, buttonText,
      } = popUpResponse;
      if (showPlanPopup === 3 || showPlanPopup === 8) {
        state.popups.showPlanPopup = showPlanPopup;
        state.popups.contactusEmail = contactusEmail;
        state.popups.popupHtml = popupHtml;
        state.popups.popupText = popupText;
        state.popups.popupHeading = popupHeading;
        state.popups.allowFullView = allowFullView;
        state.popups.callToAction = callToAction;
        state.popups.buttonText = buttonText;
      } else {
        state.popups.showPlanPopup = showPlanPopup;
        state.popups.contactusEmail = contactusEmail;
        state.popups.popupHtml = popupHtml;
        state.popups.popupText = popupText;
        state.popups.popupHeading = popupHeading;
        state.popups.allowFullView = allowFullView;
        state.popups.callToAction = callToAction;

        result.forEach((item: PersonResponseType | PersonResultType) => {
          const {
            type, data, details, count,
          } = item;
          if (type === 'personCard') {
            newData.personCard = (details as PersonCard[])?.length > 0
              ? (details as PersonCard[])[0] : {} as PersonCard;
            const personCard = (details as PersonCard[])[0];
            const insight = state.insights.insightsData.find((i) => i.type === 'compatibility') as InsightsCompatibility;
            const insightIndex = state.insights.insightsData.findIndex((i) => i.type === 'compatibility');
            if (insightIndex !== -1 && insight?.data[0]?.persons[1]) {
              insight.data[0].persons[1].personImage = personCard?.personImage;
              state.insights.insightsData[insightIndex].data = insight?.data;
            }
          }
          if (type === 'personalityInfo') {
            const personalityInfo: PersonalityInfo = {
              behaviour: {},
              motivations: {},
              qualities: {},
              communicationTips: {},
              tips: {},
              discImage: '',
            } as PersonalityInfo;

            const personalityData: PersonalityInfoResponse[] = data;
            personalityData.map((element: PersonalityInfoResponse) => {
              const {
                type: newType, dataList, description, data: dataString,
              } = element;
              if (newType === 'behaviour') {
                personalityInfo.behaviour.description = description;
              }
              if (newType === 'qualities') {
                personalityInfo.qualities.dataList = dataList;
              }
              if (newType === 'communicationTips') {
                personalityInfo.communicationTips.dataList = dataList;
              }
              if (newType === 'motivations') {
                personalityInfo.motivations.description = description;
                personalityInfo.motivations.dataList = dataList;
              }
              if (newType === 'tips') {
                personalityInfo.tips.dataList = dataList;
              }
              if (newType === 'discImage') {
                personalityInfo.discImage = dataString;
              }
              return 0;
            });
            newData.personalityInfo = personalityInfo;
          }
          if (type === 'socialLinks') { newData.socialLinks = { data: details } as SocialLinks; }
          if (type === 'career' && count === 0) {
            // const careerData = (details as PersonCareerResponseType).data;
            // const hasValidCareerData = careerData.some((item: CareerTabDataObjectType) => {
            //   const hasRequiredKeyWithData = ['data', 'dataset', 'description'].some(
            //     (key) => {
            //       const value = (item as any)[key];
            //       return value && value.length > 0;
            //     },
            //   );
            //   return hasRequiredKeyWithData && item.type !== 'currentPosition';
            // });
            newTabs = newTabs.filter((tab) => tab !== 'Career');
          }
          if (type === 'personalDetails' && count === 0) { newTabs = newTabs.filter((tab) => tab !== 'Personal'); }
        });
        state.profile.data = { ...newData };
        state.tabs = newTabs;
        state.profile.loading = false;
      }
    },
    setProfileLoading(state, action: PayloadAction<boolean>) {
      state.profile.loading = action.payload;
    },
    setPersonNotesAvailable(state, action: PayloadAction<number>) {
      const { payload } = action;
      state.personNotesAvailable = payload;
    },
    resetNewNotes(state) {
      state.newNotes = 0;
    },
    updatePersonProfileFollow(state, action: PayloadAction<UpdatePersonProfileFollow>) {
      if (!state.profile.followLoading) {
        state.profile.followLoading = true;
      }
    },

    setPersonProfileFollowSuccess(state, action: PayloadAction<UpdatePersonProfileFollow>) {
      state.profile.followLoading = false;
      const { payload } = action;
      const { feedids, person_data: personData } = payload;
      if (feedids && feedids?.length > 0) {
        state.profile.data.personCard.personAdded = false;
      } else if (personData && personData?.length > 0) {
        state.profile.data.personCard.personAdded = true;
      }
    },

    setPersonProfileFollowFailure(state, action: PayloadAction<UpdatePersonProfileFollow>) {
      state.profile.followLoading = false;
    },

    setMultiSalesPersons(state, action: PayloadAction<{ payload: MultiSalesAlignment, rowNo: number }>) {
      state.salesAlignmentPersons.loading = false;
      const { payload, rowNo } = action.payload
      const basePerson = payload?.data[0]?.persons[0];
      const personsWithAlignment: SalesAlignmentItem[] = payload.data.flatMap(item =>
        item.persons
          .filter(p => p.personId !== basePerson.personId)
          .map(person => ({
            person,
            alignment: {
              personId: person?.personId,
              match: item?.match,
              personType: person?.personType || '',
              approachTips: item?.approachTips
            }
          }))
      )
      // const temp1 = state.salesAlignmentPersons.rows;
      const exisitingRowIndex = state.salesAlignmentPersons.rows.findIndex(row => row.rowId === rowNo);

      if (exisitingRowIndex !== -1) {
        const existingRow = state.salesAlignmentPersons.rows[exisitingRowIndex];
        const existingCurrentUserId = existingRow.currentUser?.personId;
        const incomingCurrentUserId = basePerson?.personId;

        if (existingCurrentUserId && incomingCurrentUserId && existingCurrentUserId === incomingCurrentUserId) {
          const salesAlignmentItemByPersonId: Record<number, SalesAlignmentItem> = {};
          existingRow.personsList.forEach((item) => {
            if (item?.person?.personId) {
              salesAlignmentItemByPersonId[item.person.personId] = item;
            }
          });

          const newItems: SalesAlignmentItem[] = [];
          personsWithAlignment.forEach((item) => {
            const pid = item?.person?.personId;
            if (!pid) return;

            if (salesAlignmentItemByPersonId[pid]) {
              salesAlignmentItemByPersonId[pid] = item;
            } else {
              salesAlignmentItemByPersonId[pid] = item;
              newItems.push(item);
            }
          });

          existingRow.personsList = [
            ...existingRow.personsList.map((item) => {
              const pid = item?.person?.personId;
              return pid && salesAlignmentItemByPersonId[pid] ? salesAlignmentItemByPersonId[pid] : item;
            }),
            ...newItems,
          ];
        } else {
          state.salesAlignmentPersons.rows[exisitingRowIndex].currentUser = basePerson;
          state.salesAlignmentPersons.rows[exisitingRowIndex].personsList = personsWithAlignment;

          if (state.salesAlignmentInsightsCache[rowNo]?.basePersonId !== basePerson?.personId) {
            state.salesAlignmentInsightsCache[rowNo] = {
              basePersonId: basePerson?.personId ?? null,
              cellsByPersonId: {},
            };
          }
        }

      } else {
        state.salesAlignmentPersons.rows.push({
          rowId: rowNo,
          currentUser: basePerson,
          personsList: personsWithAlignment,
        })
        state.salesAlignmentInsightsCache[rowNo] = {
          basePersonId: basePerson?.personId ?? null,
          cellsByPersonId: {},
        };
      }
    },

    seedSalesAlignmentInsight(
      state,
      action: PayloadAction<{
        rowId: number;
        basePersonId: number;
        personId: number;
        approachTips?: string[];
        commonalities?: { title?: string; dataList?: string[] };
      }>,
    ) {
      const {
        rowId, basePersonId, personId, approachTips, commonalities,
      } = action.payload;

      if (!state.salesAlignmentInsightsCache[rowId] || state.salesAlignmentInsightsCache[rowId].basePersonId !== basePersonId) {
        state.salesAlignmentInsightsCache[rowId] = { basePersonId, cellsByPersonId: {} };
      }

      const existing = state.salesAlignmentInsightsCache[rowId].cellsByPersonId[personId];
      state.salesAlignmentInsightsCache[rowId].cellsByPersonId[personId] = {
        basePersonId,
        personId,
        approachTips: approachTips ?? existing?.approachTips ?? [],
        commonalitiesTitle: commonalities?.title ?? existing?.commonalitiesTitle ?? '',
        commonalitiesData: commonalities?.dataList ?? existing?.commonalitiesData ?? [],
        loading: false,
        loaded: commonalities !== undefined ? true : Boolean(existing?.loaded),
      };
    },

    getSalesAlignmentInsight(
      state,
      action: PayloadAction<{
        rowId: number;
        fromPersonId: number;
        toPersonId: number;
        approachTips?: string[];
      }>,
    ) {
      const {
        rowId, fromPersonId, toPersonId, approachTips,
      } = action.payload;

      // base person = affinity/base for this row; compared person = the column person.
      const basePersonId = fromPersonId;
      const comparedPersonId = toPersonId;

      if (!state.salesAlignmentInsightsCache[rowId] || state.salesAlignmentInsightsCache[rowId].basePersonId !== basePersonId) {
        state.salesAlignmentInsightsCache[rowId] = { basePersonId, cellsByPersonId: {} };
      }

      const existing = state.salesAlignmentInsightsCache[rowId].cellsByPersonId[comparedPersonId];
      state.salesAlignmentInsightsCache[rowId].cellsByPersonId[comparedPersonId] = {
        basePersonId,
        personId: comparedPersonId,
        approachTips: approachTips ?? existing?.approachTips ?? [],
        commonalitiesTitle: existing?.commonalitiesTitle ?? '',
        commonalitiesData: existing?.commonalitiesData ?? [],
        loading: true,
        loaded: Boolean(existing?.loaded),
      };
    },

    setSalesAlignmentInsight(
      state,
      action: PayloadAction<{
        rowId: number;
        basePersonId: number;
        personId: number;
        approachTips?: string[];
        commonalitiesTitle: string;
        commonalitiesData: string[];
      }>,
    ) {
      const {
        rowId, basePersonId, personId, approachTips, commonalitiesTitle, commonalitiesData,
      } = action.payload;

      if (!state.salesAlignmentInsightsCache[rowId] || state.salesAlignmentInsightsCache[rowId].basePersonId !== basePersonId) {
        state.salesAlignmentInsightsCache[rowId] = { basePersonId, cellsByPersonId: {} };
      }

      const existing = state.salesAlignmentInsightsCache[rowId].cellsByPersonId[personId];
      state.salesAlignmentInsightsCache[rowId].cellsByPersonId[personId] = {
        basePersonId,
        personId,
        approachTips: approachTips ?? existing?.approachTips ?? [],
        commonalitiesTitle,
        commonalitiesData,
        loading: false,
        loaded: true,
      };
    },

    setSalesAlignmentInsightFailed(
      state,
      action: PayloadAction<{ rowId: number; basePersonId: number; personId: number }>,
    ) {
      const {
        rowId, basePersonId, personId,
      } = action.payload;

      if (!state.salesAlignmentInsightsCache[rowId] || state.salesAlignmentInsightsCache[rowId].basePersonId !== basePersonId) {
        state.salesAlignmentInsightsCache[rowId] = { basePersonId, cellsByPersonId: {} };
      }

      const existing = state.salesAlignmentInsightsCache[rowId].cellsByPersonId[personId];
      state.salesAlignmentInsightsCache[rowId].cellsByPersonId[personId] = {
        basePersonId,
        personId,
        approachTips: existing?.approachTips ?? [],
        commonalitiesTitle: existing?.commonalitiesTitle ?? '',
        commonalitiesData: existing?.commonalitiesData ?? [],
        loading: false,
        loaded: Boolean(existing?.loaded),
      };
    },
    removeMultiSalesPerson(state, action: PayloadAction<{ personId: number, rowId: number }>) {
      const { personId, rowId } = action.payload;
      const rowIndex = state.salesAlignmentPersons.rows.findIndex(row => row.rowId === rowId);

      if (rowIndex === -1) return;

      state.salesAlignmentPersons.rows[rowIndex].personsList = state.salesAlignmentPersons.rows[rowIndex].personsList.filter(p => p.person.personId !== personId);

      if (state.salesAlignmentInsightsCache[rowId]?.cellsByPersonId) {
        delete state.salesAlignmentInsightsCache[rowId].cellsByPersonId[personId];
      }
    },
    addNewAlignmentRow(state) {
      const newRowId = state.salesAlignmentPersons.rows.length ? Math.max(...state.salesAlignmentPersons.rows.map(r => r.rowId)) + 1 : 1;
      state.salesAlignmentPersons.rows.push({
        rowId: newRowId,
        currentUser: null,
        personsList: [
          {
            person: state.salesAlignmentPersons.rows[0]?.personsList[0]?.person,
            alignment: {
              personId: state.salesAlignmentPersons.rows[0]?.personsList[0]?.person.personId,
              match: " ",
              personType: " ",
            }
          },
        ],
      })

      state.salesAlignmentInsightsCache[newRowId] = {
        basePersonId: null,
        cellsByPersonId: {},
      };
    },
    removeAlignmentRow(state, action: PayloadAction<number>) {
      const rowId = action.payload;
      state.salesAlignmentPersons.rows = state.salesAlignmentPersons.rows.filter(row => row.rowId !== rowId);

      if (state.salesAlignmentInsightsCache[rowId]) {
        delete state.salesAlignmentInsightsCache[rowId];
      }
    },
    setSearchedMultiSalesPerson(state, action: PayloadAction<{ person: Executive, rowId: number }>) {
      state.searchedMultiSalesPerson.person = action.payload.person;
      state.searchedMultiSalesPerson.rowId = action.payload.rowId;
      state.searchedMultiSalesPersonLoading = false;
      state.searchedAffinityMSPersonLoading = false;
      state.searchedPerson.loading = false;
    },
    setSearchedAffinityMSPerson(state, action: PayloadAction<{ person: Executive, rowId: number }>) {
      state.searchedAffinityMSPerson.person = action.payload.person;
      state.searchedAffinityMSPerson.rowId = action.payload.rowId;
      state.searchedMultiSalesPersonLoading = false;
      state.searchedAffinityMSPersonLoading = false;
      state.searchedPerson.loading = false;
    },
    resetMultiSalesAlignment(state) {
      const firstRow = state.salesAlignmentPersons.rows[0];

      if (!firstRow) {
        state.salesAlignmentPersons = { rows: [], loading: false };
        state.salesAlignmentInsightsCache = {};
        return;
      }
      const firstPerson = firstRow.personsList[0];

      state.salesAlignmentPersons.rows = [
        {
          ...firstRow,
          personsList: firstPerson ? [firstPerson] : [],
        },
      ];

      const rowId = firstRow.rowId;
      state.salesAlignmentInsightsCache = {
        [rowId]: {
          basePersonId: firstRow.currentUser?.personId ?? 0,
          cellsByPersonId: firstPerson ? {
            [firstPerson.person.personId]: {
              basePersonId: firstRow.currentUser?.personId ?? 0,
              personId: firstPerson.person.personId,
              approachTips: firstPerson.alignment?.approachTips ?? [],
              commonalitiesTitle: '',
              commonalitiesData: [],
              loading: false,
              loaded: false,
            }
          } : {},
        }
      };
      state.salesAlignmentPersons.loading = false;
    },
    getPersonProfileInsights(state, action: PayloadAction<GetPersonProfileRequest>) {
      state.insights.loading = true;
    },
    getMultipleSalesAlignment(state, action: PayloadAction<GetMultiSalesRequest>) {
      state.salesAlignmentPersons.loading = true;
    },
    setPersonProfileInsights(state, action: PayloadAction<PersonalityInsights[]>) {
      state.insights.loading = false;
      state.insights.insightsData = action.payload;
    },

    setPersonProfileInsightsInitial(state, action: PayloadAction<PersonalityInsights[]>) {
      state.searchedPerson.loading = false;
      state.searchedPerson = {
        loading: false,
        insightsData: [],
        selectedPerson: {} as Executive,
      };
      if (action.payload.length) {
        state.insights.insightsData.splice(0, 2, action.payload[0], action.payload[1]);
      }
    },

    getSearchedPersonProfileInsights(state, action: PayloadAction<GetPersonProfileRequest>) {
      state.searchedPerson.loading = true;
      state.searchedMultiSalesPersonLoading = true;
      state.searchedAffinityMSPersonLoading = true;
    },
    setSearchedPersonProfileInsights(state, action: PayloadAction<PersonalityInsights[]>) {
      state.searchedPerson.loading = false;
      state.searchedPerson.insightsData = action.payload;
      state.searchedMultiSalesPersonLoading = false;
      state.searchedAffinityMSPersonLoading = false;
    },
    getSimilarPeople(state, action: PayloadAction<SimilarPeopleRequest>) {
      state.similarPeopleData.loading = true;
    },
    setSimilarPeople(state, action: PayloadAction<PersonalityInsights>) {
      const {
        data, count, title, filters, name,
      } = action.payload;

      state.similarPeopleData.loading = false;
      state.similarPeopleData.title = title;
      state.similarPeopleData.name = name ?? '';
      state.insights.insightsData = state.insights.insightsData.concat(action.payload);
      if (state.similarPeopleData.page === 1) {
        state.similarPeopleData.people = data as Executive[];
      } else {
        state.similarPeopleData.people = state.similarPeopleData.people
          .concat(data as Executive[]);
      }
      state.similarPeopleData.count = count ?? 0;
      if (!data.length) {
        state.similarPeopleData.ended = true;
      }
      if (filters?.length && state.similarPeopleData.page === 1
        && !state.similarPeopleData.loaded) {
        state.similarPeopleFilters.filters = filters.map((filter) => ({
          ...filter,
          isSelected: true,
        }));
      }
      state.similarPeopleData.page += 1;
      state.similarPeopleData.loaded = true;
    },
    setEmptySimilarPeople(state, action: PayloadAction<Executive[]>) {
      state.similarPeopleData.loading = false;
      state.similarPeopleData.people = state.similarPeopleData.people
        .concat(action.payload);
    },
    setSimilarPeopleFilters(state, action: PayloadAction<Company[]>) {
      state.similarPeopleFilters.filters = action.payload;
    },
    setSimilarPeoplePage(state, action: PayloadAction<number>) {
      state.similarPeopleData.page = action.payload;
    },
    getSimilarPeopleExport(state, action: PayloadAction<ExportSimilarPeopleRequest>) {
      state.exportSimilarPeopleLoading = true;
    },
    setSimilarPeopleExport(state, action: PayloadAction<ResponseExport>) {
      state.exportSimilarPeopleLoading = false;
      const { url } = action.payload;
      const linkO = document.createElement('a');
      linkO.href = url;
      linkO.dispatchEvent(new MouseEvent('click'));
    },
    setSearchedPersonPopUp(state, action: PayloadAction<PopUpResponse>) {
      const {
        allowFullView, showPlanPopup,
        contactusEmail, popupHtml, popupText,
        popupHeading, callToAction,
      } = action.payload;
      state.popups.showPlanPopup = showPlanPopup;
      state.popups.contactusEmail = contactusEmail;
      state.popups.popupHtml = popupHtml;
      state.popups.popupText = popupText;
      state.popups.popupHeading = popupHeading;
      state.popups.allowFullView = allowFullView;
      state.popups.callToAction = callToAction;
    },

    getPersonProfileIntentData(state, action: PayloadAction<GetPersonProfileRequest>) {
      if (!state.intent.loading) { state.intent.loading = true; }
    },

    setPersonProfileIntentData(state, action: PayloadAction<PersonIntentData>) {
      state.intent.loading = false;
      const { payload } = action;
      const {
        results, popupHeading, popupText,
        contactusEmail, intentAllowed, url,
      } = payload;
      state.intent.data = results;
      state.intent.popupHeading = popupHeading;
      state.intent.popupText = popupText;
      state.intent.contactusEmail = contactusEmail;
      state.intent.intentAllowed = intentAllowed;
      state.intent.url = url;
    },

    setSelectedSearchedPerson(state, action: PayloadAction<Executive>) {
      state.searchedPerson.selectedPerson = action.payload;
    },

    resetSelectedSearchedPerson(state) {
      state.searchedPerson.selectedPerson = {} as Executive;
    },

    getPersonProfilePersonalDetails(state, action: PayloadAction<GetPersonProfileRequest>) {
      if (!state.personalDetails.loading) { state.personalDetails.loading = true; }
    },

    setPersonProfilePersonalDetails(state, action: PayloadAction<PersonPersonalDetailsType>) {
      const { payload } = action;
      const { data, title } = payload;
      const personalDetailsInfo: PersonProfilePersonalDetailInfo = {
        highlightedInfo: [],
        personalInfo: {
          about: '',
          address: '',
          phoneNumber: '',
          family: '',
        },
        hobbies: [],
        interests: [],
        loading: false,
        title: '',
      } as PersonProfilePersonalDetailInfo;
      personalDetailsInfo.title = title;
      if (data.length > 0) {
        data.forEach((item: PersonPersonalDetailsDataType) => {
          if (item.type === 'highlightedInfo') {
            personalDetailsInfo.highlightedInfo = item.data;
          }
          if (item.type === 'personalInfo') {
            // personalDetailsInfo.personalInfo = item.data as PersonPersonalInfo[];
            const personalInfo: PersonPersonalInfo = {} as PersonPersonalInfo;
            item.data.forEach((element: PersonHighlightedInfo) => {
              if (element.title === 'About') {
                personalInfo.about = element.description;
              }
              if (element.title === 'Phone Number') {
                personalInfo.phoneNumber = element.description;
              }
              if (element.title === 'Address') {
                personalInfo.address = element.description;
              }
              if (element.title === 'Family members') {
                personalInfo.family = element.description;
              }
            });
            personalDetailsInfo.personalInfo = personalInfo;
          }

          if (item.type === 'hobbies') {
            personalDetailsInfo.hobbies = item.dataList;
          }
          if (item.type === 'manuelInterests') {
            personalDetailsInfo.interests = item.dataList;
          }
        });
      }
      state.personalDetails = personalDetailsInfo;
    },

    getPersonProfileCareer(state, action: PayloadAction<GetPersonProfileRequest>) {
      if (!state.career.loading) { state.career.loading = true; }
    },

    setPersonProfileCareer(state, action: PayloadAction<PersonCareerResponseType>) {
      const { payload } = action;
      const { data, title } = payload;
      state.career.title = title;
      state.career.loading = false;
      const object = {
        achievements: {},
        manualAchievements: {},
        skills: {},
        boardsAndCommittees: {},
        manualBoardsAndCommittees: {},
        volunteerWork: {},
        workHistory: {},
        educationHistory: {},
        currentPosition: {},
        goals: {},
        initiative: {},
        compensationSalary: {},
      } as PersonProfileCareer;
      data.forEach((item) => {
        const {
          type, title: Title, data: Data, dataList, description,
        } = item;
        if (type === 'achievements') {
          object.achievements.title = Title;
          object.achievements.data = Data as PersonAchievementType[];
        }
        if (type === 'manualAchievements') {
          object.manualAchievements.title = Title;
          object.manualAchievements.data = Data as PersonManualBoardAndCommitteesDataObject[];
        }
        if (type === 'skills') {
          object.skills.title = Title;
          object.skills.data = dataList;
        }
        if (type === 'boardsAndCommittees') {
          object.boardsAndCommittees.title = Title;
          object.boardsAndCommittees.data = Data as string[];
        }
        if (type === 'manualBoardsAndComittees') {
          object.manualBoardsAndCommittees.title = Title;
          object
            .manualBoardsAndCommittees.data = Data as PersonManualBoardAndCommitteesDataObject[];
        }
        if (type === 'volunteerWork') {
          object.volunteerWork.title = Title;
          object.volunteerWork.data = Data as PersonManualBoardAndCommitteesDataObject[];
        }
        if (type === 'groupExperience') {
          object.workHistory.title = Title;
          object.workHistory.data = description;
        }
        if (type === 'educationHistory') {
          object.educationHistory.title = Title;
          object.educationHistory.data = Data as PersonEducationDataType[];
        }
        if (type === 'currentPosition') {
          object.currentPosition.title = Title;
          object.currentPosition.data = Data as PersonCurrentPositionCompanyDataType[];
        }
        if (type === 'goals') {
          object.goals.title = Title;
          object.goals.data = Data as string[];
        }
        if (type === 'initiative') {
          object.initiative.title = Title;
          object.initiative.data = Data as string[];
        }
        if (type === 'compensationSalary') {
          object.compensationSalary.title = Title;
          object.compensationSalary.data = Data as PersonManualBoardAndCommitteesDataObject[];
        }
        state.career = { ...state.career, ...object };
      });
    },

    getPersonProfileNews(state, action: PayloadAction<GetPersonProfileRequest>) {
      if (!state.news.loading) {
        state.news.loading = true;
      }
    },

    setPersonProfileNews(state, action: PayloadAction<PersonNews>) {
      if (state.news.loading) { state.news.loading = false; }
      const { payload } = action;
      const { articles, title } = payload;
      const seenIds = new Set(state.news.seenArticleIds ?? []);

      const newArticles = articles.filter((article) => !seenIds.has(article.articleId));
      newArticles.forEach((article) => seenIds.add(article.articleId));

      state.news.articles.push(...newArticles);
      state.news.title = 'News';
      state.news.seenArticleIds = Array.from(seenIds);

      if (state.news.page === 0 && articles.length === 0
        && state.workbenchStats.isEmptyWorkbenchStats) {
        let newTabs = state?.tabs;
        newTabs = newTabs.filter((tab) => tab !== 'News');
        state.tabs = newTabs;
        state.news.title = '';
        state.news.articles = [];
      } else {
        state.news.page += 1;
      }
    },

    getPersonProfileVideos(state, action: PayloadAction<GetPersonProfileSocialRequest>) {
      const { payload } = action;
      if (payload.page === 1) {
        state.video.articles = [];
        state.video.page = 1;
      }
      state.video.loading = true;
    },

    setPersonProfileVideos(state, action: PayloadAction<PersonVideosType>) {
      if (state.video.loading) { state.video.loading = false; }
      const { payload } = action;
      const { articles: articlesData } = payload;
      state.video.articles = articlesData.articles;
      if (state.video.page === 1 && articlesData.articles.length === 0) {
        const newTabs = state?.tabs;
        state.tabs = newTabs.filter((tab) => tab !== 'Videos');
      }
    },

    setMorePersonProfileVideos(state, action: PayloadAction<PersonVideosType>) {
      const { payload } = action;
      const { articles: articlesData } = payload;
      state.video.loading = false;
      state.video.articles = [...state.video.articles, ...articlesData.articles];
      state.video.page += 1;
    },

    getPersonProfileDownload(state, action: PayloadAction<GetPersonProfileRequest>) {
      if (!state.downloadProfile.loading) { state.downloadProfile.loading = true; }
    },

    setPersonProfileDownload(state, action: PayloadAction<PersonProfileDownloadType>) {
      if (state.downloadProfile.loading) { state.downloadProfile.loading = false; }
      const { payload } = action;
      const {
        link, showPlanPopup, popupText, popupHeading, contactusEmail,
      } = payload;
      state.downloadProfile.loading = false;

      if (showPlanPopup === 3 || showPlanPopup === 4 || showPlanPopup === 5) {
        state.popups.popupHeading = popupHeading ?? '';
        state.popups.popupText = popupText ?? '';
        state.popups.showPlanPopup = showPlanPopup;
        state.popups.contactusEmail = contactusEmail ?? '';
        state.popups.isDownloadPopup = true;
      } else {
        state.downloadProfile.link = link;
        const linkO = document.createElement('a');
        linkO.href = link;
        const name = state.profile.data.personCard.personName;
        linkO.download = `${name.replace(' ', '')}_xiQ_Profile.pdf`;
        linkO.dispatchEvent(new MouseEvent('click'));
      }
    },

    failPersonProfileDownload(state, action: PayloadAction<string>) {
      if (state.downloadProfile.loading) { state.downloadProfile.loading = false; }
    },

    setPopupValues(state, action: PayloadAction<PopupValuesType>) {
      const { payload } = action;
      const {
        popupHeading, popupText, showPlanPopup, contactusEmail,
      } = payload;
      state.popups.popupHeading = popupHeading;
      state.popups.popupText = popupText;
      state.popups.showPlanPopup = showPlanPopup;
      state.popups.contactusEmail = contactusEmail;
    },

    showGenerateContentRestrictedAccessPopup(state, action: PayloadAction<boolean>) {
      const { payload } = action;
      if (payload) {
        const { contactusEmail, popupHeading, popupText } = state.intent;
        state.popups.popupHeading = popupHeading;
        state.popups.popupText = popupText;
        state.popups.contactusEmail = contactusEmail;
        state.popups.showPlanPopup = 6;
      }
    },

    resetPersonPopups(state) {
      state.popups.popupHeading = '';
      state.popups.popupText = '';
      state.popups.showPlanPopup = 0;
      state.popups.contactusEmail = '';
      state.popups.isDownloadPopup = false;
    },
    getPersonWorkbenchStats(state, action: PayloadAction<number>) {
      if (state.workbenchStats.loading === false) { state.workbenchStats.loading = true; }
      state.workbenchStats.data = [];
      state.workbenchStats.isEmptyWorkbenchStats = true;
    },
    setPersonWorkbenchStats(state, action: PayloadAction<WorkbenchStatsResponseType[]>) {
      const { payload } = action;
      if (payload) {
        state.workbenchStats.loading = false;
        state.workbenchStats.data = payload;
        state.workbenchStats.isEmptyWorkbenchStats = false;
        const index = state.tabs.indexOf('News');
        if (index === -1) {
          const arr = state.tabs;
          arr.splice(1, 0, 'News');
          state.tabs = arr;
        }
      }
    },
    setEmptyPersonWorkbenchStats(state) {
      state.workbenchStats.loading = false;
      state.workbenchStats.data = [];
      state.workbenchStats.isEmptyWorkbenchStats = true;
    },
    failPersonWorkbenchStats(state, action: PayloadAction<string>) {
      if (state.workbenchStats.loading) { state.workbenchStats.loading = false; }
      state.workbenchStats.isEmptyWorkbenchStats = false;
    },
    addToFavoriteSuccess(state, action: PayloadAction<AddToFavoriteRequest>) {
      const { articleId, favoriteFlag } = action.payload;
      if (articleId) {
        if (state.news && state.news.articles.length) {
          const matchedArticles = state.news.articles.filter(
            (article) => article.articleId === articleId,
          );
          if (matchedArticles.length > 0) {
            matchedArticles.forEach((arrayItem) => {
              const article = arrayItem;
              article.isFavorite = favoriteFlag === 1;
            });
          }
        }
      }
    },
    setSocialFlurry(state, action: PayloadAction<object>) {
      const { payload } = action;
      state.socialFlurry = payload;
    },
    setVideoFlurry(state, action: PayloadAction<object>) {
      const { payload } = action;
      state.videoFlurry = payload;
    },
    setNewsFlurry(state, action: PayloadAction<object>) {
      const { payload } = action;
      state.newsFlurry = payload;
    },
    setNewsCall(state, action: PayloadAction<boolean>) {
      const { payload } = action;
      state.newsApiCall = payload;
    },
    setSocialCall(state, action: PayloadAction<boolean>) {
      const { payload } = action;
      state.socialApiCall = payload;
    },
    setVideoCall(state, action: PayloadAction<boolean>) {
      const { payload } = action;
      state.socialApiCall = payload;
    },
    setPersonalityDrawerOpen(state, action: PayloadAction<boolean>) {
      state.personalityDrawerOpen = action.payload;
    },
    getPersonCareerCompany(state, action: PayloadAction<PersonCompanyCareer>) {

    },
    setPersonCareerCompany(state, action: PayloadAction<PersonCompanyCareer>) {
      const { payload } = action;
      const { career } = state;
      if (career.workHistory && career.workHistory && state.career.workHistory.data.length) {
        career.workHistory.data = career.workHistory.data.map((d) => {
          if (d.fullName === payload.companyName) {
            return { ...d, companyId: payload.companyId };
          }

          return d;
        });
      }

      state.career = career;
    },
    generateEmail(state, action: PayloadAction<GenerateEmail>) {
      const { payload } = action;
      state.email.emailLoading = true;
      state.email.generateEmailData = payload;
      state.feedbackSubmitted = false;
    },
    setChat(state, action: PayloadAction<GeneratedEmail>) {
      const {
        body, subject, responseId, prompt,
      } = action.payload;
      const updatedBody = body.replace(/\n/g, '<br />');
      const senderName = getLocalStorageValue('fullname');
      const data = {
        subject,
        body: updatedBody.replace(/\[Your Name\]/gi, senderName || ''),
        prompt,
        responseId,
      };
      state.email.generatedEmail = data;
      state.email.generatedEmailView = true;
      state.email.emailLoading = false;
    },
    setGenerateEmailLoading(state, action: PayloadAction<boolean>) {
      state.email.emailLoading = action.payload;
    },
    setGeneratedEmailView(state, action: PayloadAction<boolean>) {
      state.email.generatedEmailView = action.payload;
    },
    sendFeedback(state, action: PayloadAction<EmailFeedback>) {

    },
    setFeedbackSubmitted(state, action: PayloadAction<boolean>) {
      state.feedbackSubmitted = action.payload;
    },
    handleSimilarPeopleFollowUnfollow(state, action: PayloadAction<number[]>) {
      const { payload } = action;
      const index = state.similarPeopleData.people
        .findIndex((person) => person.personId === payload[0]);
      if (index !== -1) {
        const flag = state.similarPeopleData.people[index].personAdded;
        state.similarPeopleData.people[index].personAdded = !flag;
      }
    },
    saveProfile(state, action: PayloadAction<number>) {
      state.similarPeopleData.savedId = action.payload;
    },
    editPhoneEmail(state, action: PayloadAction<EditPhoneEmailRequest>) {
      state.editPhoneEmailLoading = true;
    },
    phoneEmailEdited(state, action: PayloadAction<EditPhoneEmailRequest>) {
      state.editPhoneEmailLoading = false;
      if (action.payload.email) {
        state.profile.data.personCard.email = action.payload.email;
      } else if (action.payload.phone) {
        state.profile.data.personCard.phone = action.payload.phone;
      }
    },
    setEditPhoneEmailLoading(state, action: PayloadAction<boolean>) {
      state.editPhoneEmailLoading = action.payload;
    },
    setIsEditingEmail(state, action: PayloadAction<boolean>) {
      state.isEditingEmail = action.payload;
    },
    setIsEditingPhone(state, action: PayloadAction<boolean>) {
      state.isEditingPhone = action.payload;
    },
    setIsRecommended(state, action: PayloadAction<boolean>) {
      state.isRecommended = action.payload;
    },
    setSalesForcePersonSearchLoading(state, action: PayloadAction<boolean>) {
      state.insights.loading = action.payload;
      state.profile.loading = action.payload;
    },
    resetWithoutSimiarPeople: (state) => ({
      ...initialState,
      similarPeopleData: state.similarPeopleData,
      similarPeopleFilters: state.similarPeopleFilters,
      exportSimilarPeopleLoading: state.exportSimilarPeopleLoading,
    }),
    reset: (state) => ({
      ...initialState,
      isRecommended: state.isRecommended,
    }),
    getPersonCommonalities(state, action: PayloadAction<GetPersonCommonalitesRequest>) {
      state.commonalities.loading = true;
    },
    setPersonCommonalities(state, action: PayloadAction<CommonalitiesData>) {
      state.commonalities.dataList = action.payload?.dataList;
      state.commonalities.title = action.payload?.title;
      state.commonalities.loading = false;
    },
    getPersonGroups(state, action: PayloadAction<GetAllGroups>) {
      state.commonGroups.loading = true;
    },
    setPersonGroups(state, action: PayloadAction<MostActiveGroups>) {
      const { payload } = action;
      state.commonGroups.loading = false;
      if (payload.groupCount) {
        state.commonGroups.count = payload.groupCount;
      }
      if (payload.data) {
        state.commonGroups.allPersonGroups = payload.data;
        state.commonGroups.loaded = true;
      }
    },
    getPersonFaqs(state, action: PayloadAction<GetPersonProfileRequest>) {
      state.personFaqs.loading = true;
      state.personFaqs.faqs = [];
    },
    setPersonFaqs(state, action: PayloadAction<string[]>) {
      state.personFaqs.faqs = action.payload || [];
      state.personFaqs.loading = false;
    },
    getPersonFaqsFailed(state) {
      state.personFaqs.loading = false;
    },
    resetPersonFaqs(state) {
      state.personFaqs = { loading: false, faqs: [] };
    },
    setFaqsLoading(state, action: PayloadAction<boolean>) {
      state.personFaqs.loading = action.payload;
    },
    addAlignmentPeople(state, action: PayloadAction<NotableStaffRequest>) {
      const { payload } = action;
      const rowId = payload.rowId ?? 0;
      if (!state.alignmentPeopleStaff[rowId]) {
        state.alignmentPeopleStaff[rowId] = { page: 0, count: 0, loading: false, staff: [] };
      }
      if (payload.page === 1) {
        state.alignmentPeopleStaff[rowId].staff = [];
        state.alignmentPeopleStaff[rowId].page = payload.page;
        state.alignmentPeopleStaff[rowId].count = 0;
      }
      state.alignmentPeopleStaff[rowId].loading = true;
    },
    setAlignmentPeopleStaff(state, action: PayloadAction<NotableStaff & { rowId?: number }>) {
      const rowId = action.payload.rowId ?? 0;
      if (!state.alignmentPeopleStaff[rowId]) {
        state.alignmentPeopleStaff[rowId] = { page: 0, count: 0, loading: false, staff: [] };
      }
      if (state.alignmentPeopleStaff[rowId].page === 1) {
        state.alignmentPeopleStaff[rowId].staff = action.payload.data;
        state.alignmentPeopleStaff[rowId].count = action.payload.count;
      } else {
        state.alignmentPeopleStaff[rowId].staff = state.alignmentPeopleStaff[rowId].staff.concat(action.payload.data);
      }
      state.alignmentPeopleStaff[rowId].page += 1;
      state.alignmentPeopleStaff[rowId].loading = false;
    },
    addAlignmentRow(state, action: PayloadAction<NotableStaffRequest>) {
      const { payload } = action;
      const rowId = payload.rowId ?? 0;

      if (!state.alignmentRowStaff[rowId]) {
        state.alignmentRowStaff[rowId] = {
          page: 0,
          count: 0,
          loading: false,
          staff: [],
        };
      }

      if (payload.page === 1) {
        state.alignmentRowStaff[rowId].staff = [];
        state.alignmentRowStaff[rowId].page = payload.page
        state.alignmentRowStaff[rowId].count = 0;
      }
      state.alignmentRowStaff[rowId].loading = true;
    },
    setAlignmentRowStaff(state, action: PayloadAction<NotableStaff & { rowId?: number }>) {
      const rowId = action.payload.rowId ?? 0;

      if (!state.alignmentRowStaff[rowId]) {
        state.alignmentRowStaff[rowId] = {
          page: 1,
          count: 0,
          loading: false,
          staff: [],
        };
      }

      if (state.alignmentRowStaff[rowId].page === 1) {
        state.alignmentRowStaff[rowId].staff = action.payload.data;
        state.alignmentRowStaff[rowId].count = action.payload.count;
      } else {
        state.alignmentRowStaff[rowId].staff = state.alignmentRowStaff[rowId].staff.concat(action.payload.data);
      }
      state.alignmentRowStaff[rowId].page += 1;
      state.alignmentRowStaff[rowId].loading = false;
    },
    pushCurrentSection(state, action: PayloadAction<string>) {
      const item = action.payload;
      if (item === 'null') {
        state.currentSections = [];
      } else {
        if (!state.currentSections.includes(item)) {
          state.currentSections.push(item);
        }
        if (item === 'xiQ insights') {
          const index = state.currentSections.indexOf('News');
          if (index !== -1) {
            state.currentSections.splice(index, 1);
          }
        }
      }
    },
    removeCurrentSection(state, action: PayloadAction<string>) {
      const item = action.payload;
      const index = state.currentSections.indexOf(item);
      if (index !== -1) {
        state.currentSections.splice(index, 1);
      }
    },
  },
});

export const { actions, reducer, name: sliceKey } = PersonProfileSlice;
